<template>
  <div class="cp-contact-view">
    <div class="cp-contact-view-breadcrumbs-container">
      <!-- <Breadcrumbs /> -->
    </div>
          <img class="cp-about-logo" :src="contact.company_image" />
    <XContainer>
      <br />
      <img src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-28_9yTwyh4cWLO.jpg"
      width="100%"
      class="cover-image">
      <p
        class="cp-contact-view-title title is-4 is-size-4-mobile has-text-centered has-text-black"
      >
        CONTACT US
      </p>
      <div class="cp-contact-view-container columns is-mobile is-multiline">
         <div class="column is-12-desktop is-12-mobile is-12-tablet">
        </div>
        <div class="column is-12-mobile is-12-tablet is-6-desktop">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1267.0193199790247!2d100.53834994400741!3d13.75237665762056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x70c035ea81c54064!2sSoi%20Phetchaburi%2019!5e0!3m2!1sen!2sth!4v1613480110346!5m2!1sen!2sth"
            width="100%"
            height="700"
            frameborder="0"
            class="cp-contact-view-map"
            style="border:0"
            allowfullscreen=""
            aria-hidden="false"
            tabindex="0"
          ></iframe>
        </div>
        <div class="column is-12-mobile is-12-tablet is-6-desktop">
          <Contact
            class="cp-contact-view-contact"
            :logo="company.logo_image"
            :logo-white="company.logo_image_white"
            :company-name="company.company_name_localized"
            :address="contact.address_localized"
            :email="contact.email"
            :telephone="contact.phone_number"
            :line="contact.line_id"
          />
        </div>
      </div>
    </XContainer>

    <!-- <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1937.685798955235!2d100.56138285831759!3d13.756450402857777!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29e92b3cda7e5%3A0xccfdef5da0bd1516!2s544%2F26%20Din%20Daeng%20Rd%2C%20Khwaeng%20Din%20Daeng%2C%20Khet%20Din%20Daeng%2C%20Krung%20Thep%20Maha%20Nakhon%2010400!5e0!3m2!1sen!2sth!4v1599583598015!5m2!1sen!2sth"
      width="100%"
      height="700"
      frameborder="0"
      class="cp-contact-view-map"
      style="border:0"
      allowfullscreen=""
      aria-hidden="false"
      tabindex="0"
    ></iframe> -->
    <OrderFloatIcon />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Contact from '@/components/Contact.vue';
// import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue';
import XContainer from '@/components/XContainer.vue';
// import SmallSellerSection from '@/components/SmallSellerSection.vue';
import OrderFloatIcon from '@/components/OrderFloatIcon.vue';

export default {
  name: 'ContactView',
  components: {
    Contact,
    // Breadcrumbs,
    XContainer,
    OrderFloatIcon,
    // SmallSellerSection,
  },
  computed: mapState({
    company: state => state.company,
    contact: state => state.contact,
  }),
  watch: {
    company() {
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    contact() {
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.cover-image{
  margin-top:-5%;
  @media screen and (max-width: 769px) {
      margin-top:-15%;
    }
}
.cp-contact-view {
  &-title{
    margin-top: 50px;
  }
  &-breadcrumbs-container {
    border-top: 1px solid $primary;
    border-bottom: 1px solid $primary;
  }

  &-container {
    padding-top: 40px;
    padding-bottom: 40px;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }

  &-submit {
    margin-bottom: 15px;
    @media screen and (max-width: 769px) {
      width: 200px;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
  }

  &-contact {
    @media screen and (min-width: 769px) {
      margin-left: 30px;
    }
  }

  &-facebook-page {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  &-contact-button {
    max-width: 80%;
    display: block;
    margin: auto;
    cursor: pointer;
  }

  &-map {
    height: 600px;

    @media screen and (max-width: 768px) {
      height: 400px;
    }
  }
}
</style>
